import React, {Component} from 'react';

import './styles/finish.scss';
import axios from "axios";
import {eventEcommercePurchase} from "../../helpers/analytics";
import {addDays, addMonths, format, subDays} from "date-fns";
import {separate} from "../../helpers/separate";
import {Privileges} from "../CardWhite/Privileges";
import {urlParam} from "../../helpers/urlParam";
import Cookies from "js-cookie";

export default class Finish extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            status: '',
            result: '',
            callRequestSuccess: false,
            hasActiveContract: false,
            hasActiveSubscription: false,
            hadContract: false,
            card: null
        }
    }

    componentDidMount() {
        this.setState({
            result: urlParam('result'),
            hasActiveContract: localStorage.getItem('hasActiveContract') == 1,
            hasActiveSubscription: localStorage.getItem('hasActiveSubscription') == 1,
            hadContract: localStorage.getItem('hadContract') == 1,
            card: JSON.parse(localStorage.getItem('card'))
        })

        if (this.state.result == 'testdriveerror' || this.state.result == 'subscription-error') {
            this.setState({
                loading: false
            });
        } else {
            this.checkStatus()
        }
    }

    checkStatus() {
        let self = this,
            data = {
                id: localStorage.getItem('orderId'),
                method: localStorage.getItem('paymentMethod'),
                subscription: localStorage.getItem('subscription')
            }

        if (!data.id || data.id == 'null') {
            self.setState({
                loading: false
            });
        } else {
            axios.post(`${process.env.REACT_APP_FITRON_URL}/check-payment-status`, data, {
                headers: {
                    'Content-type': 'application/json',
                }
            }).then((response) => {
                // console.log('response', response);
                if (response.status === 200) {
                    if (response.data.error) {
                        self.setState({
                            loading: false,
                        });
                        return false;
                    }

                    if (response.data) {
                        if (response.data.status) {
                            self.setState({
                                loading: false,
                                status: response.data.status
                            });
                            if (response.data.status == 'succeeded') {
                                eventEcommercePurchase({
                                    'id': localStorage.getItem('cardId'),
                                    'title': localStorage.getItem('cardTitle'),
                                    'price': localStorage.getItem('cardPrice'),
                                    'orderId': data.id
                                })
                                localStorage.removeItem('orderId')
                            }
                        }
                    }
                }
            }).catch(function (error) {
                // console.log('error', error.response);
                self.setState({
                    loading: false
                });
            });
        }
    }

    requestCall() {
        let self = this

        self.setState({
            loading: true
        });

        axios.post(`${process.env.REACT_APP_FITRON_URL}/call-request`, {
            name: localStorage.getItem('name'),
            club: localStorage.getItem('club'),
            phone: localStorage.getItem('phone'),
            email: localStorage.getItem('email'),
            roistat_visit: Cookies.get('roistat_visit'),
            subscription: self.state.result == 'subscription-error',
            agreements: localStorage.getItem('agreements'),
        }, {
            headers: {
                'Content-type': 'application/json',
            }
        }).then((response) => {
            // console.log('response', response);
            if (response.status === 200) {
                if (response.data.error) {
                    self.setState({
                        loading: false,
                    });
                    return false;
                }

                self.setState({
                    callRequestSuccess: true,
                    loading: false,
                });
            }
        }).catch(function (error) {
            // console.log('error', error.response);
            self.setState({
                loading: false
            });
        });
    }

    calculateAge(birthDateString) {
        let birthDateArr = birthDateString.split('.'),
          birthDate = new Date(birthDateArr[2], birthDateArr[1]-1, birthDateArr[0]),
          nowDate = new Date()

        return (nowDate - birthDate)/1000/60/60/24/365.2425
    }

    finishDate() {
        return this.state.card ? (this.state.card.resultCard.subscription
          ? addDays(new Date(this.state.card.customerData.activationDate), 29)
          : subDays(addMonths(new Date(this.state.card.customerData.activationDate), this.state.card.duration + this.state.card.freezing), 1)
        ) : ''
    }

    nextChargeDate() {
        return this.state.card ? addDays(new Date(this.state.card.customerData.activationDate), 26) : ''
    }

    secondTotalDuration () {
        return this.state.card ? (this.calculateAge(this.state.card.customerData.secondBirthDate) < 18 ?
          this.state.card.resultCard.teen_card_base_months + this.state.card.resultCard.teen_card_base_freezing_months :
            subDays(addMonths(new Date(this.props.customerData.activationDate), this.props.duration + this.props.freezing), 1)
        ) : ''
    }

    secondFinishDate() {
        return this.state.card ? subDays(addMonths(new Date(this.state.card.customerData.secondActivationDate), this.secondTotalDuration()), 1) : '';
    }

    render() {
        const clubNames = {
            gazetniy: "Газетный",
            gorizont: "Горизонт",
            orbita: "Орбита",
            millenium: "Миллениум",
        }

        const club = localStorage.getItem('club')

        return (
          <div className="container">
              <div className="finish">
                  {
                    this.state.status == 'succeeded' && this.state.card
                        ? <div className="finish__body">
                            <div className="finish__body__info">
                                <h2>Оплата прошла успешно!</h2>
                                <p>Будем рады видеть вас в клубах сети FITRON!</p>
                                <a href="/" className="btn">На главную</a>
                            </div>
                            <div className="finish__body__card">
                                <div className="finish__body__card__header">
                                    <h2>Ваш контракт</h2>
                                    {
                                        this.state.card.custom ?
                                          <div className="title">
                                              {this.state.card.duration} месяц{this.state.card.duration > 4 ? 'ев' : (this.state.card.duration > 1 ? 'а' : '')} фитнеса
                                              {this.state.card.freezing ?
                                                <span> + {this.state.card.freezing * 30} дней заморозки</span> : ''}</div>
                                          : <div className={'title ' + this.state.card.resultCard.header_class}
                                                 dangerouslySetInnerHTML={{__html: this.state.card.resultCard.title}}></div>
                                    }
                                </div>

                                <div className="finish__body__card__body" ref={(ref) => this.ref = ref}>
                                    <p className="passport-warning">Отправили вам логин и пароль от личного кабинета на указанную почту.<br/><br/>
                                        Там сможете посмотреть всю информацию по вашему тарифу / записаться на любую тренировку / воспользоваться подарками уникальной программы лояльности Fitron.</p>

                                    <div className="specification">
                                        <div className="clubs">
                                            <div>
                                                <p className="title">Клубы</p>
                                                {
                                                    this.state.card.resultCard.clubs.gazetniy ?
                                                      <p><img
                                                        src={require("../../static/images/icons/check-blue.svg").default}/>
                                                          <b>Газетный</b> / Красноармейская, 170</p>
                                                      : ''
                                                }
                                                {
                                                    this.state.card.resultCard.clubs.gorizont ?
                                                      <p><img
                                                        src={require("../../static/images/icons/check-blue.svg").default}/>
                                                          <b>Горизонт</b> / пр. М. Нагибина, 32e</p>
                                                      : ''
                                                }
                                                {
                                                    this.state.card.resultCard.clubs.orbita ?
                                                      <p><img
                                                        src={require("../../static/images/icons/check-blue.svg").default}/>
                                                          <b>Орбита</b> / Королева, 10/4</p>
                                                      : ''
                                                }
                                                {
                                                    this.state.card.resultCard.clubs.millenium || this.state.card.milleniumAdded ?
                                                      <p><img
                                                        src={require("../../static/images/icons/check-blue.svg").default}/>
                                                          <b>Миллениум</b> / Соборный, 94 г</p>
                                                      : ''
                                                }
                                            </div>
                                        </div>
                                        {
                                            this.state.card.resultCard.subscription ?
                                              <div className="duration">
                                                  Срок действия контракта 30
                                                  дней, <b>с&nbsp;{format(new Date(this.state.card.customerData.activationDate), 'dd.MM.yyyy')} по {format(this.finishDate(), 'dd.MM.yyyy')}</b>
                                                  <br/><b>Автоматическое продление.<br/>Следующий платёж будет списан {format(this.nextChargeDate(), 'dd.MM.yyyy')}</b></div> :
                                              <div>
                                                  <div className="duration">
                                                      {
                                                          this.state.card.resultCard.test_drive ?
                                                            <p>1 день фитнеса</p> :
                                                            (
                                                              this.state.card.resultCard.visit_count_fixed ?
                                                                <span>{separate(Math.round(this.state.card.resultCard.visit_count_fixed))} посещени{String(this.state.card.resultCard.visit_count_fixed).endsWith(1) ? 'е' : ('234'.includes(String(this.state.card.resultCard.visit_count_fixed).substr(-1, 1)) ? 'я' : 'й')} активного фитнеса в течение года</span>
                                                                :
                                                                <p>{this.state.card.duration} месяц{this.state.card.duration > 4 ? 'ев' : (this.state.card.duration > 1 ? 'а' : '')} активного
                                                                    фитнеса</p>
                                                            )
                                                      }
                                                      {this.state.card.freezing ?
                                                        <p>+ {this.state.card.freezing * 30} дней заморозки</p> : ''}
                                                  </div>
                                                  {
                                                      this.state.card.resultCard.family ?
                                                        <div className="duration">
                                                            <h2>Контракт №2</h2>
                                                            {
                                                                this.calculateAge(this.state.card.customerData.secondBirthDate) < 18 ?
                                                                  <div>
                                                                      <p>{this.state.card.resultCard.teen_card_base_months} месяц{this.state.card.resultCard.teen_card_base_months > 4 ? 'ев' : (this.state.card.resultCard.teen_card_base_months > 1 ? 'а' : '')} активного
                                                                          фитнеса</p>
                                                                      {this.state.card.resultCard.teen_card_base_freezing_months ?
                                                                        <p>+ {this.state.card.resultCard.teen_card_base_freezing_months * 30} дней
                                                                            заморозки</p> : ''}
                                                                  </div> :
                                                                  <div>
                                                                      <p>{this.state.card.duration} месяц{this.state.card.duration > 4 ? 'ев' : (this.state.card.duration > 1 ? 'а' : '')} активного
                                                                          фитнеса</p>
                                                                      {this.state.card.freezing ?
                                                                        <p>+ {this.state.card.freezing * 30} дней
                                                                            заморозки</p> : ''}
                                                                  </div>
                                                            }
                                                        </div>
                                                        : ''
                                                  }
                                                  {this.state.card.resultCard.comfort ? <p className='comfort-tip'>
                                                      <b>Время посещения ограничено</b>
                                                      <br/><br/>Доступ в клуб в будние дни:
                                                      <ul style={{paddingLeft: '15px', marginTop: '5px'}}>
                                                          <li>с 7:00 до 17:00 (FITRON Газетный с 6:00 до 17:00)</li>
                                                          <li>с 21:00 до 23:00</li>
                                                      </ul>
                                                      <br/>Выходные и праздничные дни без ограничений
                                                  </p> : ''}
                                                  {this.state.card.resultCard.youth ? <p className='comfort-tip'>
                                                      <b>Только для клиентов возрастом от 15 до 18 лет</b>
                                                      <br/><br/><b>Время посещения ограничено</b>
                                                      <br/>Доступ в клуб с 7:00 до 17:00
                                                      <br/>(FITRON Газетный с 6:00 до 17:00)
                                                  </p> : ''}
                                                  {
                                                      this.state.card.resultCard.test_drive || !this.state.card.customerData.activationDate ? '' :
                                                        <div className="period">
                                                            <div>Период действия
                                                                контракта{this.state.card.resultCard.family ? ' №1' : ''}</div>
                                                            <div>
                                                                <b
                                                                  className="period">с {format(new Date(this.state.card.customerData.activationDate), 'dd.MM.yyyy')} по {format(this.finishDate(), 'dd.MM.yyyy')}</b>
                                                            </div>
                                                            {
                                                                this.state.card.resultCard.family ?
                                                                  <div>
                                                                      <div>Период действия контракта №2</div>
                                                                      <div>
                                                                          <b
                                                                            className="period">с {format(new Date(this.state.card.customerData.secondActivationDate), 'dd.MM.yyyy')} по {format(this.secondFinishDate(), 'dd.MM.yyyy')}</b>
                                                                      </div>
                                                                      <div className="attention">Для завершения оформления
                                                                          контрактов и подтверждения личности вам необходимо прийти с оригиналами
                                                                          паспортов в отдел продаж выбранного клуба. При оформлении
                                                                          контракта на ребенка до 14 лет, необходимо иметь с собой
                                                                          оригинал свидетельства о рождении
                                                                      </div>
                                                                  </div> :
                                                                  <div className="attention">Для завершения оформления контракта и подтверждения личности вам необходимо прийти с оригиналом паспорта в отдел продаж выбранного клуба</div>
                                                            }
                                                        </div>
                                                  }
                                              </div>
                                        }
                                        {
                                            /*
                                            resultCard.title == 'Ultra' ?
                                              <div className="period">
                                                  <div className="attention">При покупке карты Ultra по промокоду AQUA
                                                      вы также получаете доступ в новую аквазону FITRON Millenium.
                                                      Доступ предоставляется на месяц с момента открытия аквазоны
                                                  </div>
                                              </div>
                                              : ''
                                             */
                                        }
                                    </div>

                                    <Privileges
                                      privileges={this.state.card.resultCard.privileges}
                                      milleniumAdded={this.state.card.milleniumAdded || this.state.card.resultCard.clubs.millenium}
                                      millenium_privileges={this.state.card.resultCard.millenium_privileges}
                                      towel={this.state.card.resultCard.test_drive && this.state.card.resultCard.includes.towel}
                                      testDrive={this.state.card.resultCard.test_drive}
                                      family={this.state.card.resultCard.family}
                                      subscription={this.state.card.resultCard.subscription}
                                    ></Privileges>

                                    <div className="customer-info">
                                        <h3>Данные владельца контракта</h3>
                                        <p>{this.state.card.customerData.name}</p>
                                        <p>{this.state.card.customerData.phone}</p>
                                        <p>{this.state.card.customerData.email}</p>
                                        <p>{this.state.card.customerData.birthDate}</p>
                                    </div>

                                    <div className="price-amount">
                                        <h3>Стоимость</h3>
                                        <p>Новый период — {this.state.card.finalPrice} ₽</p>
                                        {this.state.card.resultCard.subscription ? <p>Продление — {Math.ceil(this.state.card.resultCard.cost_month_base + (this.state.card.milleniumAdded ? this.state.card.resultCard.millenium_add_price : 0))} ₽</p> : '' }
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <div className="message-container">
                            <div className="finish__img">
                                {
                                    this.state.loading ?
                                      <img src={require('../../static/images/loading.gif')} alt=""/> :
                                      this.state.status == 'succeeded'
                                        ? <img src={require('../../static/images/icons/finish-success.svg').default}
                                               alt="success"/>
                                        : <img src={require('../../static/images/icons/finish-error.svg').default}
                                               alt="error"/>
                                }
                            </div>
                            <div className="finish__text">
                                {
                                    this.state.result == 'testdriveerror' ?
                                      (
                                        this.state.hasActiveContract
                                            ? <h3>У вас уже есть действующий контракт FITRON!</h3>
                                            : this.state.hadContract
                                                ? <h3>Ваш контракт в Fitron {clubNames[club] ?? ''} закончился совсем недавно</h3>
                                                : <h3>Приобрести тест-драйв можно только один раз</h3>
                                      ) : (
                                        this.state.result == 'subscription-error' ? (
                                            this.state.hasActiveSubscription
                                              ? <h3>У вас уже есть действующая подписка FITRON!</h3>
                                              : <h3>У вас уже есть действующий контракт FITRON!</h3>
                                          ) : this.state.loading ? <h3>Получаем статус оплаты</h3> :
                                                this.state.status == 'succeeded'
                                                    ? <h3>Оплата прошла успешно!</h3>
                                                    : <h3>Оплата не&nbsp;прошла!</h3>
                                      )
                                }
                                {
                                    this.state.result == 'testdriveerror' ?
                                      (
                                        this.state.hasActiveContract
                                            ? <p>Можете посетить клуб в любое удобное время.</p>
                                            : this.state.hadContract
                                                ? <p>Приобрести тест-драйв вы сможете не ранее чем через полгода с даты окончания контракта.</p>
                                                : <p>Если у вас остались вопросы о клубе или вы хотите посетить его еще раз, менеджер свяжется с вами</p>
                                      ) : this.state.result == 'subscription-error' ? (
                                          this.state.hasActiveSubscription
                                            ? <p>Информацию можно посмотреть в&nbsp;<a href="https://lk.fitron.club" style={{textDecoration: 'underline'}}>личном&nbsp;кабинете</a><br/>Если хотите связаться с менеджером, закажите обратный звонок</p>
                                            : <p>Если хотите связаться с менеджером, закажите обратный звонок</p>
                                        ) : (
                                            this.state.loading ? '' :
                                                this.state.status == 'succeeded'
                                                  ?
                                                  <p>На&nbsp;твою почту пришло письмо с&nbsp;инструкцией, когда можно начать
                                                      тренировки
                                                      и&nbsp;что взять с&nbsp;собой.</p>
                                                  : <p>Кажется что-то пошло не&nbsp;так. Попробуй еще раз через некоторое время
                                                      или
                                                      позвони по&nbsp;номеру&nbsp;<a href="tel:78633109566">
                                                          <nobr>+7 (863) 310-95-66</nobr>
                                                      </a></p>
                                        )
                                }
                            </div>
                            <div className="finish__btn">
                                {
                                    this.state.result == 'testdriveerror' ? <p>
                                          {this.state.hasActiveContract ? '' : (this.state.callRequestSuccess ?
                                            <p style={{marginTop: '20px', textAlign: "center"}}>Запрос отправлен</p> :
                                            <button className="btn _type-2" style={{marginTop: '20px'}}
                                                    onClick={() => this.requestCall()}>Заказать обратный звонок</button>)}
                                          <a href="/" className="btn _type-2" style={{marginTop: '20px'}}>Выбрать другой тариф</a>
                                      </p> :
                                      this.state.result == 'subscription-error' ?
                                        <p>
                                            {this.state.callRequestSuccess ?
                                              <p style={{marginTop: '20px', textAlign: "center"}}>Запрос отправлен</p> :
                                              <button className="btn _type-2" style={{marginTop: '20px'}}
                                                      onClick={() => this.requestCall()}>Заказать обратный звонок</button>}
                                            {this.state.hasActiveSubscription ? <a href="https://lk.fitron.club" className="btn _type-2" style={{marginTop: '20px'}}>Перейти в личный кабинет</a> : ''}
                                        </p>
                                        :
                                          this.state.loading ? '' :
                                            this.state.status == 'succeeded'
                                              ? <a href="https://fitron.club/" className="btn _type-2">На главную</a>
                                              : (localStorage.getItem('paymentLink') && localStorage.getItem('paymentLink') != 'null' ?
                                                <a href={localStorage.getItem('paymentLink')} className="btn _type-2">Попробовать
                                                    снова</a> : '')
                                }
                            </div>
                        </div>
                  }
              </div>
          </div>
        )
    }
}